import * as React from 'react';

import { TextLink } from '@lightspeed/flame/Text';

import { createReactRenderer } from 'helpers/react-renderer';
import TooltipHelp from 'root/apps/Tooltip/components/TooltipHelp';

import useLocalizedLink from '../hooks/useLocalizedLink';

const NetworkHealthMonitorTooltip = () => {
  const SUPPORT_ARTICLE_URL = useLocalizedLink(
    'https://retail-support.lightspeedhq.com/hc/{{locale}}/articles/1260800114289-Networking-best-practices'
  );

  const content = (
    <>
      Monitors your network health and connectivity to ensure your devices are connected and
      performing as expected.{' '}
      <TextLink
        href={SUPPORT_ARTICLE_URL}
        target="_blank"
        rel="noopener noreferrer"
        fontWeight={600}
        style={{ textDecoration: 'none', color: 'white' }}
      >
        {' '}
        Learn more
      </TextLink>
    </>
  );
  return (
    <div style={{ position: 'absolute', top: '8px', left: '170px' }}>
      <TooltipHelp content={content} placement="top-start" />
    </div>
  );
};

export default NetworkHealthMonitorTooltip;

const RenderedComponent = createReactRenderer({
  component: NetworkHealthMonitorTooltip,
  selector: '[data-react-root="NetworkHealthMonitorTooltip"]',
});

history.onChangeState(
  [{ name: ['admin.views.shop'], form_name: 'view', tab: 'details' }],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
